import { render, staticRenderFns } from "./ConfigDropdown.vue?vue&type=template&id=0f7bf4e1"
import script from "./ConfigDropdown.vue?vue&type=script&lang=js"
export * from "./ConfigDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports